<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{ $t("message.货品详情编辑") }}</span>
      </div>
      <div class="topContainer">
        <div class="grid-content content-margin topFix">
          <div class="buttonarea">
            <el-link :underline="false">
              <el-button size="medium" round @click.native="goBack">
                <i class="iconfont">&#xe600;</i>
                {{ $t("message.返回") }}
              </el-button>
            </el-link>
            <el-link :underline="false" v-show="!isEditMode && !isInit">
              <el-button size="medium" round @click="edit">
                <i class="iconfont">&#xe618;</i>
                {{ $t("message.修改") }}
              </el-button>
            </el-link>
            <el-link :underline="false" v-show="isEditMode">
              <el-button size="medium" round @click="doSave" type="primary">
                <i class="iconfont">&#xe769;</i>
                {{ $t("message.保存") }}
              </el-button>
            </el-link>
            <el-link :underline="false" v-show="!isInit">
              <el-button size="medium" round @click.native="refresh">
                <i class="iconfont">&#xe667;</i>
                {{ $t("message.刷新") }}
              </el-button>
            </el-link>
          </div>
        </div>
      </div>
      <div class="grid-content subtitle">
        <span>货品主信息</span>
      </div>
      <div class="grid-content content-margin">
        <el-divider></el-divider>
        <table class="simpleRow">

            <tr v-if="shelvesid > 0">
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.货品ID") }}</span>
                    </td>
                    <td>
                        <el-input v-model="commodityid" size="mini"    readonly placeholder="" style="width: 500px">
                        </el-input>
                    </td>
            </tr>
            <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.货品名称") }}</span>
                    </td>
                    <td>
                        <el-input :readonly="!isEditMode" size="mini" class="linkTextArea" v-model="name"
                            type="textarea" :placeholder="$t('message.请输入货品名称')" maxlength="50" show-word-limit>
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("*货品编号") }}</span>
                    </td>
                    <td>
                        <el-input v-model="commodityno" size="mini" :disabled="!isEditMode" placeholder="" style="width: 500px">
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.货品图片") }}</span>
                    </td>
                    <td>
                        <!-- 图片库控件 -->
                        <div :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'" @click="doShowResourceStore(1)">
                            <i class="iconfont" v-if="!img">&#xe727;</i>
                            <el-popover placement="right" trigger="hover" v-else>
                                <img :src="img" alt="" style="max-width: 500px; max-height: 500px" />
                                <img slot="reference" :src="img" />
                                <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle
                                    @click.native="img = ''"></el-button>
                            </el-popover>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("货品库存锁定减扣外挂模块") }}</span>
                    </td>
                    <td>
                        <!-- <el-input v-model="commoditygrantmodule" size="mini" :disabled="!isEditMode" placeholder="" style="width: 500px">
                        </el-input> -->
                        <el-input-number v-model="commoditygrantmodule" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.条形码") }}</span>
                    </td>
                    <td>
                        <el-input v-model="barcode" size="mini" :disabled="!isEditMode" placeholder="" style="width: 500px">
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.货品种类") }}</span>
                    </td>
                    <td>
                        <el-radio-group :disabled="!isEditMode" v-model="isvirtual">
                            <el-radio :label="0">实体货品</el-radio>
                            <el-radio :label="1">虚拟货品</el-radio>
                            <el-radio :label="2">人工服务类</el-radio>
                            <el-radio :label="3">套装货品</el-radio>
                            <el-radio :label="4">多sku商品（采用选中商品的sku）</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr v-if="isvirtual >= '3'">
                    <td></td>
                    <td>
                        <chooseGoods :tableData.sync='GoodstableData' :isModify='isEditMode' ></chooseGoods>
                    </td>
                </tr>
                <tr v-if="isvirtual != '2'">
                    <td>
                        <span class="simpleLabel">*快递发货库存类型</span>
                    </td>
                    <td>
                        <el-radio-group :disabled="!isEditMode" v-model="manualstocktype" >
                            <!-- <el-radio :label="0">{{ $t("message.不计算库存") }}</el-radio> -->
                            <el-radio :label="1">{{ $t("message.门店内部库存") }}</el-radio>
                            <el-radio :label="2">{{ $t("message.门店外部库存") }}</el-radio>
                            <el-radio :label="3">{{ $t("message.仓库库存") }}</el-radio>
                            <!-- <el-radio :label="4">{{ $t("message.双重检查库存") }}</el-radio> -->
                            <el-radio :label="4">三重检查库存</el-radio>
                            <el-radio :label="5">优先门店库存,不足使用仓库库存</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr  v-if="isvirtual != '2'">
                    <td>
                        <span class="simpleLabel">*门店自提库存类型</span>
                    </td>
                    <td>
                        <el-radio-group :disabled="!isEditMode" v-model="writeoffstocktype" >
                            <!-- <el-radio :label="0">{{ $t("message.不计算库存") }}</el-radio> -->
                            <el-radio :label="1">{{ $t("message.门店内部库存") }}</el-radio>
                            <el-radio :label="2">{{ $t("message.门店外部库存") }}</el-radio>
                            <el-radio :label="3">{{ $t("message.仓库库存") }}</el-radio>
                            <el-radio :label="4">三重检查库存</el-radio>
                            <el-radio :label="5">优先门店库存,不足使用仓库库存</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.库存编号") }}</span>
                    </td>
                    <td>
                        <el-input v-model="stockcod" size="mini" placeholder="" style="width: 500px" :disabled="!isEditMode">
                        </el-input>
                    </td>
                </tr>
                <!-- <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.产品名称") }}</span>
                    </td>
                    <td>
                        <el-input :readonly="!isEditMode" size="mini" class="linkTextArea" v-model="name"
                            type="textarea" :placeholder="$t('message.请输入产品名称')" maxlength="50" show-word-limit>
                        </el-input>
                    </td>
                </tr> -->
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.重量") }}</span>
                    </td>
                    <td>
                        <el-input-number v-model="weight" :min="0" label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.是否使用门店价格") }}</span>
                    </td>
                    <td>
                        <el-radio-group :disabled="!isEditMode" v-model="useshopprice">
                            <el-radio :label="0">{{ $t("message.不使用") }}</el-radio>
                            <el-radio :label="1">{{ $t("message.使用") }}</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.出售价格") }}</span>
                    </td>
                    <td>
                        <el-input-number v-model="price" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                    </td>
                </tr>
                <tr>
                    <!-- <td style="padding-left: 20px"> -->
                    <td>
                        <span class="simpleLabel">{{ $t("message.获得积分组") }}</span>
                    </td>
                    <td>
                        <el-select :disabled="!isEditMode" size="small" v-model="buypointsgroup"
                            :placeholder="$t('message.请选择')" clearable  @select="pointgrouplist">
                            <el-option v-for="item in pointgrouplists" :key="item.groupid" :label="item.name"
                                :value="item.groupid" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.获得积分") }}</span>
                    </td>
                    <td>
                        <el-input-number v-model="buypoints" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.大小") }}</span>
                    </td>
                    <td>
                      <el-input-number v-model="size" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                        <!-- <el-input size="mini" class="linkTextArea" v-model="size" type="text"  :disabled="!isEditMode">
                        </el-input> -->
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.包装大小") }}</span>
                    </td>
                    <td>
                        <!-- <el-input size="mini" class="linkTextArea" v-model="packagesize" type="text"  :disabled="!isEditMode">
                        </el-input> -->
                        <el-input-number v-model="packagesize" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                    </td>
                </tr>
                <tr>
                    <!-- <td style="padding-left: 20px"> -->
                    <td>
                        <span class="simpleLabel">{{ $t("message.生产地") }}</span>
                    </td>
                    <td>
                        <el-select :disabled="!isEditMode" size="small" v-model="productionplace"
                            :placeholder="$t('message.请选择')" clearable>
                            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                :value="item.value" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.最小进货数量") }}</span>
                    </td>
                    <td>
                      <el-input-number v-model="replenishmin" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                        <!-- <el-input size="mini" class="linkTextArea" v-model="replenishmin" type="text"  :disabled="!isEditMode">
                        </el-input> -->
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.统一进货价") }}</span>
                    </td>
                    <td>
                      <el-input-number v-model="replenishprice" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                        <!-- <el-input size="mini" class="linkTextArea" v-model="replenishprice" type="text" :disabled="!isEditMode">
                        </el-input> -->
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.型号") }}</span>
                    </td>
                    <td>
                        <el-input :readonly="!isEditMode" size="mini" class="linkTextArea" v-model="modelno"
                            type="textarea" :placeholder="$t('message.请输入产品型号')"  show-word-limit>
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.跳转链接") }}</span>
                    </td>
                    <td>
                        <el-input :readonly="!isEditMode" size="mini" class="linkTextArea" v-model="jumpurl"
                            type="textarea" :placeholder="$t('message.请输入链接')"  show-word-limit>
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <!-- <td style="padding-left: 20px"> -->
                    <td>
                        <span class="simpleLabel">{{ $t("message.消费积分组") }}</span>
                    </td>
                    <td>
                        <el-select :disabled="!isEditMode" size="small" v-model="costpointsgroup"
                            :placeholder="$t('message.请选择')" clearable>
                            <el-option v-for="item in pointgrouplists" :key="item.groupid" :label="item.name"
                                :value="item.groupid" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">*消费积分</span>
                    </td>
                    <td>
                        <el-input-number v-model="costpoints" :min="0"  label="描述文字" size="small" :disabled="!isEditMode">
                        </el-input-number>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.领取方式") }}</span>
                    </td>
                    <td>
                        <el-checkbox-group :disabled="!isEditMode" v-model="receivetype">
                            <el-checkbox v-for="item in classifyPostState" :label="item.value" :key="item.key">
                                {{item.key}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="simpleLabel">上架时间(仅商城显示用)</span>
                    </td>
                    <td>
                        <!-- <el-time-select v-model="ruleForm.onshelves" :picker-options="{
                          start: '08:30',
                          step: '00:15',
                          end: '18:30'
                        }" placeholder="选择时间">
                        </el-time-select> -->
                        <el-date-picker v-model="onshelves" type="date" placeholder="选择日期"  :disabled="!isEditMode">
                        </el-date-picker>
                    </td>
                </tr>
                <!-- <tr>
                    <td>
                        <span class="simpleLabel">*库存类型</span>
                    </td>
                    <td>
                        <el-radio-group :disabled="!isEditMode" v-model="stocktype" >
                            <el-radio :label="1">{{ $t("message.普通库存") }}</el-radio>
                            <el-radio :label="2">{{ $t("message.外部库存") }}</el-radio>
                        </el-radio-group>
                    </td>
                </tr> -->
                
                <tr>
                    <td>
                        <span class="simpleLabel">*货品状态</span>
                    </td>
                    <td>
                        <el-radio-group :disabled="!isEditMode" v-model="state">
                            <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
                            <el-radio :label="1">{{ $t("message.已下架") }}</el-radio>
                            <el-radio :label="2">{{ $t("message.不显示") }}</el-radio>
                            <el-radio :label="3">{{ $t("message.测试数据") }}</el-radio>
                            <!-- <el-radio :label="4">{{ $t("message.已删除") }}</el-radio> -->
                        </el-radio-group>
                    </td>
                </tr>
                <tr v-if="shelvesid > 0">
                    <td>
                        <span class="simpleLabel">{{ $t("message.创建人") }}</span>
                    </td>
                    <td>
                        <el-input readonly size="mini" :placeholder="idtoname(createid)" />
                    </td>
                </tr>
                <tr v-if="shelvesid > 0">
                    <td>
                        <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
                    </td>
                    <td>
                        <el-input readonly v-model="createdate" size="mini" placeholder="" />
                        <!-- <el-date-picker v-model="ruleForm.createdate" type="date" placeholder="选择日期"  :disabled="!isEditMode">
                        </el-date-picker> -->
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px" >
                        <span class="simpleLabel">创建者</span>
                    </td>
                    <td>
                        <el-input v-model="createid"   size="mini" placeholder=""  :disabled="!isEditMode" readonly
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">创建日期</span>
                    </td>
                    <td>
                        <!-- <el-input v-model="ruleForm.createdate"   size="mini" placeholder=""
                            style="width:  500px"></el-input> -->
                            <el-date-picker v-model="createdate" type="date" placeholder="选择日期" readonly :disabled="!isEditMode">
                        </el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.更新者") }}</span>
                    </td>
                    <td>
                        <el-input v-model="editid" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:100px">
                        <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
                    </td>
                    <td>
                        <el-input v-model="editdate" :disabled="!isEditMode" readonly size="mini" placeholder=""
                            style="width:  500px" ></el-input>
                    </td>
                </tr>
        </table>
      </div>

      <!-- <div class="grid-content content-margin" v-if="isvirtual == '3'">
        <el-divider></el-divider>
        <div>
        </div> 
      </div> -->


  
      <shade v-if="showResourceStore > 0">
        <resource-store
          :shadeShow="showResourceStore > 0"
          @onClick="onResourceStoreCallback"
          :appID="appid"
        ></resource-store>
      </shade>
    </div>
  </template>
  
  <script>
  import commonUtil from "@/utils/commonUtil";
  import { topfixfunc } from "@/utils/topFix";
  import ResourceStore from "@/components/resourceStore/resourceStore";
  import shade from "@/components/shade/shade";
  import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import { pushdata, idtoname } from "@/utils/minxins";
  import goodsSelection from "@/components/elementSelect/goodsSelection";
  import chooseGoods from "@/components/elementSelect/chooseGoods.vue";
  
  export default {
    name: "productDetail",
    components: {
      shade,
      ResourceStore,
      goodsSelection,
      chooseGoods,

    },
    data() {
      return {
        classifyPostState:[
                {
                    key:'邮寄',
                    value:1
                },
                {
                    key:'自提',
                    value:2
                }
            ],
            tableHeight: 500,
            appid: 0,
            shelvesid: 0,
            commodityid:0, //进过修改，预览按钮进来
            name: "",
            name2: "",
            brandid: "",
            typeOptions: [
                {
                    value: "0",
                    label: "加载中..",
                    disabled: true,
                },
            ],
            goodstypeOptions: [
              {
                value: "0",
                label: "实体货品",
              },
              {
                value: "1",
                label: "虚拟货品",
              },
              {
                value: "2",
                label: "人工服务类",
              },
              {
                value: "3",
                label: "套装货品",
              },
            ],
            pointgrouplists:[],
            value:'',
            img: "",
            shelvesinfo: "",
            jumpurl: "",
            isrecommend: "0", //推荐标识可删
            searchcount: 0,
            viewcount: 0,
            createdate: "",
            createid: "",
            idtoname: idtoname,
            editdate: "",
            editid: "",
            isEditMode:true,
            isInit: true,
            showResourceStore: false,
            deleteDialogVisible: false,
            showDateilDrawer: false,
            d_img: "",
            d_jumpurl: "",
            d_isShowSwitch: true,
            d_sort: 0,
            tableData: [],
            targetRow: null,
            tableDataKey: 0,
            commodityid:this.commodityid,
            shopid: null,  //门店限定货品

            appid: 188,
            commodityno: '', //货品编号 必传数据
            costpoints:0, //必传数据  积分价格
            onshelves: "",  //必传数据 //上架时间
            state: 0,   // 必传数据 货品状态 0正常，1已下架 2不显示
            //stocktype: "",  //必传数据  //库存类型 1普通库存 2外部库存
            manualstocktype:1,
            writeoffstocktype :1,
            commoditygrantmodule:'', //货品库存锁定减扣外挂模块
            barcode:'', //二维码
            isvirtual: 0, //货品种类 0实体货品 1虚拟货品(拍下不减数量,不维护库存) 2人工服务类(库存要查看排班)  3套装货品
            img:'',     //图片
            name:'',    //货品名称
            weight:null,  //重量
            useshopprice: "", //是否使用门店价格 0不使用 1使用
            price:null,           //出售价格
            buypointsgroup:'',  //获得积分组
            buypoints:null,  //获得积分
            size: '',        //尺寸 长宽高之类的
            packagesize: '',  //包装尺寸 长宽高之类的
            productionplace: '',  //生产地
            replenishmin: 0,   //最小进货数量
            replenishprice: 0,  //统一进货价
            modelno: '',    //型号
            jumpurl: '',    //外部跳转链接
            costpointsgroup:'', //消费积分组
            stockcod: '',  //库存编号
            receivetype:[1,2], //领取方式，1邮寄 2自提
            receivetype1:0, //领取方式，1邮寄 2自提
            editid:null,   //创建者
            createdate:'', //创建日期
            editid:null,   //编辑者
            editDate:'', //编辑日期
            // createDate:'',
            // editDate:'',
            // teststate:'上海',//测试状态
            // stockCod:'',  //库存编号
            // postagePoints:'', //邮费积分
            // writeoffValidityType:'1',  //核销国企类型 1永久有效 2固定时间 3领取够有效时间
            // writeoffValidity:'', //核销有效时间
            GoodstableData:[],//选择货品
            activityid:0,
            sets:[],//子货品的数量
      };
    },
    mounted () {

        //this.ruleForm.receiveType = this.numtoarr(7)
        this.receivetype = this.numtoarr(this.receivetype1)
        // 用来监听el-main滚动事件
        topfixfunc();
        //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
    },
    watch: {},
    methods: {
        lookgoodstabledata(){
          console.log('查看选择货品返回的gGoodstableData',this.GoodstableData);
        },
        // 监听滚动事件
        numtoarr(num){
            var res=[],
            flag=1
            while(flag<=num){
                if(num&flag){
                    res.push(flag)
                }
                flag*=2
            }
            return res
        },
        arrtonum(arr){
            var res=0
            arr.forEach(i=>{
                res+=i
            })
            return res
        },
        doShowResourceStore(type) {
            if (!this.isEditMode) return;
            this.showResourceStore = type;
        },
        onResourceStoreCallback(doc) {
            console.log(doc);
            if (doc) {
                switch (this.showResourceStore) {
                    case 1:
                        this.img = doc.resourceID;
                        break;
                    case 2:
                        this.d_img = doc.resourceID;
                        break;
                    case 3:
                        this.posterImg = doc.resourceID;
                        this.multiselect = doc.multiselect
                        // console.log(doc)
                        break;
                    case 4:
                        this.videoUrl = doc.resourceID;
                        break;
                    case 5:
                        this.videoCover = doc.resourceID;
                }
                this.showResourceStore = 0;
            } else {
                this.showResourceStore = 0;
            }
        },
        goBack() {
            this.$router.go(-1); //返回上一层
        },
      edit(){
        this.isEditMode = true;
        this.refresh()
      },
      doSave() {
        this.isEditMode = false;
        //保存发送前，进行必填字段的验证
        // if (this.commodityno === "") {
        //   this.$message({
        //     type: "error",
        //     message: this.$t("message.货品编号不能为空"),
        //   });
        //   return;
        // }
        if (this.costpoints === "") {
          this.$message({
            type: "error",
            message: this.$t("message.消费积分不能为空"),
          });
          return;
        }
        if(this.manualstocktype===''){
          console.log('空')
             this.$message({
              type: "error",
              message: this.$t("message.快递发货库存类型不能为空"),
            });
          return;
        }
        if (this.writeoffstocktype ==='') {
          this.$message({
            type: "error",
            message: this.$t("message.门店自提库存类型不能为空"),
          });
          return;
        }
        // console.log('state',this.state)
        if (this.state === '') {
          this.$message({
            type: "error",
            message: this.$t("message.货品状态不能为空"),
          });
          return;
        }
        this.receivetype = this.arrtonum(this.receivetype)
        this.isEditMode = false;
        let commodity = {
          appid: this.appid,
          name :this.name.trim(),
          commodityid  :  this.commodityid ,
          commoditygrantmodule:this.commoditygrantmodule,
          buypointsgroup:this.buypointsgroup,
          shopid  :  this.shopid ,
          commodityno  :  this.commodityno ,
          costpoints  :  this.costpoints ,
          onshelves  :  this.onshelves ,
          state  :  this.state ,
          manualstocktype:this.manualstocktype,
          writeoffstocktype :this.writeoffstocktype ,
          barcode  :  this.barcode ,
          img  :  this.img ,
          weight  :  this.weight ,
          useshopprice  :  this.useshopprice ,
          price  :  this.price ,
          buypoints  :  this.buypoints ,
          size  :  this.size ,
          packagesize  :  this.packagesize ,
          productionplace  :  this.productionplace ,
          replenishmin  :  this.replenishmin ,
          replenishprice  :  this.replenishprice ,
          modelno  :  this.modelno ,
          jumpurl  :  this.jumpurl ,
          stockcod  :  this.stockcod ,
          receivetype  :  this.receivetype ,
          receivetype1  :  this.receivetype ,
          editid  :  this.editid ,//创建者
          createdate: "2021-07-21T07:17:22.619Z",
          createid: null,
          editdate: "2021-07-21T07:17:22.619Z",
          editid: null,
          isvirtual: this.isvirtual,
          costpointsgroup:this.costpointsgroup
        };
        var sawdata={}
        var childs=null
        var sets=[{
          commodityid:0,
          masterid:0,
          quantity:0
        }]
        //当货品种类选择人工服务类，快递发货库存类型和门店自提库存类型 发0
        if(commodity.isvirtual==='2'){
          commodity.manualstocktype =0
          commodity.writeoffstocktype =0
        }
        sawdata.commodity = commodity
        sawdata.childs = childs //可不传
        //处理掉this.GoodstableData中name
        // this.GoodstableData.forEach(item => {
        //   if (item.name) {
        //   // 删除name属性
        //   delete item.name;
        //   }
        // })
        sawdata.sets=this.GoodstableData
        if (this.isInit){
          rejecthttp(
            true,
            "post",
            "/manage/commodity/addcommdoity",
            sawdata,
            this,
            (doc) => {
              changeflagCLOSED(doc, 1, this);
              if (doc.data.Code == "MSGKEY_OK") {
                  this.$message({
                      type: "success",
                      message: doc.data.Message,
                    });
              }
            }
          );
        }else {
          rejecthttp(
            true,
            "post",
            "/manage/commodity/updatecommdoity",
            sawdata,
            this,
            (doc) => {
              changeflagCLOSED(doc, 1, this);
              if (doc.data.Code == "MSGKEY_OK") {
                    this.$message({
                      type: "success",
                      message: doc.data.Message,
                    });
              }
            }
          );
        }
      },
      doSaveDetail() {
        if (this.targetRow) {
          this.targetRow.img = this.d_img;
          this.targetRow.jumpurl = this.d_jumpurl;
          this.targetRow.isshow = this.d_isShowSwitch ? 1 : 0;
          this.targetRow.sort = this.d_sort;
        } else {
          let item = {
            img: this.d_img,
            jumpurl: this.d_jumpurl,
            isshow: this.d_isShowSwitch ? 1 : 0,
            sort: this.d_sort,
          };
          console.log(this.tableData)
          this.tableData.push(item);
        }
        this.sortTableData();
        this.showDateilDrawer = false;
      },
      doSavePosterDetail() {
        if (this.posterRow) {
          this.posterRow.img = this.posterImg;
          this.posterRow.jumpurl = this.posterJumpUrl;
          this.posterRow.isshow = this.posterIsShowSwitch ? 1 : 0;
          this.posterRow.sort = this.posterSort;
        } else {
          // let item = {
          //   img: this.posterImg,
          //   jumpurl: this.posterJumpUrl,
          //   isshow: this.posterIsShowSwitch ? 1 : 0,
          //   sort: this.posterSort,
          // };
          for(let i =0 ;i<this.multiselect.length;i++){
            let item={
              img: this.multiselect[i].url,
            jumpurl: this.posterJumpUrl,
            isshow: this.posterIsShowSwitch ? 1 : 0,
            sort: this.posterSort,
            }
          this.posterData.push(item);
  
          }
        }
        this.sortPoster();
        this.showPosterDateilDrawer = false;
      },
  
      doSaveVideoDetail() {
        if (this.videoRow) {
          this.videoRow.video = this.videoUrl;
          this.videoRow.cover = this.videoCover;
          this.videoRow.isshow = this.videoIsShowSwitch ? 1 : 0;
          this.videoRow.channelsid = this.channelsid;
          this.videoRow.programid = this.programid;
          this.videoRow.sort = this.videoSort;
  
          console.log(this.videoData);
        } else {
          let item = {
            video: this.videoUrl,
            cover: this.videoCover,
            isshow: this.videoIsShowSwitch ? 1 : 0,
            channelsid: this.channelsid,
            programid: this.programid,
            sort: this.videoSort,
          };
          this.videoData.push(item);
        }
        this.sortVedio();
        this.showVideoDateilDrawer = false;
      },
  
      refresh() {
          //获取货品详细信息
          rejecthttp(
                false,
                "get",
                "/manage/point/pointgrouplist",
                 { appid: "188", search: "" },
                this,
                (doc) => {
                    if (doc.data.Code != "MSGKEY_OK") {
                    } else {
                        // this.$message({
                        // type: "success",
                        // message:"获取积分组接口成功"
                        //  });
                        console.log(doc.data.data[0].name)
                        this.pointgrouplists = doc.data.data
                        console.log(this.pointgrouplists)
                    }
                }
            );
        
        this.$http
          .get("/manage/commodity/getcommodityinfo", {
            params: {
              appid: this.appid,
              commodityid : this.shelvesid,
            },
          })
          .then((doc) => {
            if (doc.data.Code != "MSGKEY_OK") {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            } else {
              console.log('111',doc.data);
              //渲染货品数据
              this.name = doc.data.data.commodity.name;
              this.commodityid = doc.data.data.commodity.commodityid;
              this.shopid = doc.data.data.commodity.shopid;
              this.commodityno = doc.data.data.commodity.commodityno;
              this.costpoints = doc.data.data.commodity.costpoints;
              this.onshelves = doc.data.data.commodity.onshelves;
              this.state = doc.data.data.commodity.state;
              this.manualstocktype = doc.data.data.commodity.manualstocktype;
              this.writeoffstocktype = doc.data.data.commodity.writeoffstocktype;
              this.barcode = doc.data.data.commodity.barcode;
              this.img = doc.data.data.commodity.img;
              this.weight = doc.data.data.commodity.weight;
              this.useshopprice = doc.data.data.commodity.useshopprice;
              this.commoditygrantmodule =doc.data.data.commodity.commoditygrantmodule;
              this.buypointsgroup = doc.data.data.commodity.buypointsgroup;
              this.price = doc.data.data.commodity.price;
              this.buypoints = doc.data.data.commodity.buypoints;
              this.size = doc.data.data.commodity.size;
              this.packagesize = doc.data.data.commodity.packagesize;
              this.productionplace = doc.data.data.commodity.productionplace;
              this.replenishmin = doc.data.data.commodity.replenishmin;
              this.replenishprice = doc.data.data.commodity.replenishprice;
              this.modelno = doc.data.data.commodity.modelno;
              this.jumpurl = doc.data.data.commodity.jumpurl;
              this.stockcod = doc.data.data.commodity.stockcod;
              this.receivetype = doc.data.data.commodity.receivetype;
              this.receivetype1 = doc.data.data.commodity.receivetype;
              this.receivetype = this.numtoarr(this.receivetype)
              this.editid = doc.data.data.commodity.editid;//创建者
              this.createdate = commonUtil.formatDate(doc.data.data.commodity.createdate);
              this.createid = doc.data.data.commodity.createid;
              this.editdate = commonUtil.formatDate(doc.data.data.commodity.editdate);
              this.editid = doc.data.data.commodity.editid;
              this.isvirtual = doc.data.data.commodity.isvirtual;
              this.costpointsgroup = doc.data.data.commodity.costpointsgroup;
              //渲染套装内货品
              // this.GoodstableData = doc.data.data.childs
              //渲染套装内货品数量
              this.sets = doc.data.data.sets
              // console.log('查看this.GoodstableData',this.GoodstableData)
              // console.log('查看this.sets',this.sets)
              let childobj={}
              doc.data.data.childs.forEach((item,index)=>{
                childobj[item.commodityid]=index
              })
              // console.log('查看childobj',childobj)
              doc.data.data.sets.forEach(item=>{
                doc.data.data.childs[childobj[item.commodityid]].quantity=item.quantity
              })
              this.GoodstableData = doc.data.data.childs
            }
          });
      },
      getBooleanName(bool) {
        return commonUtil.getBooleanName(bool);
      },
      createTarget() {
        //清空值
        this.targetRow = null;
        this.d_img = "";
        this.d_jumpurl = "";
        this.d_isShowSwitch = true;
        this.d_sort = 0;
  
        this.showDateilDrawer = true;
      },
      createPoster() {
        this.posterRow = null;
        this.posterImg = "";
        this.posterJumpUrl = "";
  
        this.posterIsShowSwitch = true;
        this.posterSort = 0;
  
        this.showPosterDateilDrawer = true;
      },
  
      createVideo() {
        this.videoRow = null;
        this.videoUrl = "";
        this.videoCover = "";
        this.channelsid = "";
        this.programid = "";
        this.videoIsShowSwitch = true;
        this.videoSort = 0;
  
        this.showVideoDateilDrawer = true;
      },
  
      editTarget(data, edit) {
        this.targetRow = data;
        //赋值
        this.d_img = this.targetRow.img;
        this.d_jumpurl = this.targetRow.jumpurl;
        this.d_isShowSwitch = this.targetRow.isshow == 1 ? true : false;
        this.d_sort = this.targetRow.sort;
        this.showDateilDrawer = true;
      },
      editPoster(data, edit) {
        this.posterRow = data;
        //赋值
        this.posterImg = this.posterRow.img;
        this.posterJumpUrl = this.posterRow.jumpurl;
        this.posterIsShowSwitch = this.posterRow.isshow == 1 ? true : false;
        this.posterSort = this.posterRow.sort;
        this.showPosterDateilDrawer = true;
      },
  
      editVideo(data, edit) {
        console.log("editVideo", this.videoData);
        this.videoRow = data;
        //赋值
        this.channelsid = this.videoRow.channelsid;
        this.programid = this.videoRow.programid;
        this.videoUrl = this.videoRow.video;
        console.log("aaaaaaaa", this.videoUrl);
        this.videoCover = this.videoRow.cover;
        this.videoIsShowSwitch = this.videoRow.isshow == 1 ? true : false;
        this.videoSort = this.videoRow.sort;
        this.showVideoDateilDrawer = true;
      },
  
      deleteTarget() {
        console.log(this.targetRow);
        let index = this.tableData.findIndex((item) => {
          if (item == this.targetRow) {
            return true;
          }
        });
        this.tableData.splice(index, 1);
        this.deleteDialogVisible = false;
      },
  
      deletePoster() {
        console.log(this.posterRow);
        let index = this.posterData.findIndex((item) => {
          if (item == this.posterRow) {
            return true;
          }
        });
        this.posterData.splice(index, 1);
        this.deletePosterDialogVisible = false;
      },
  
      deleteVideo() {
        console.log(this.videoRow);
        let index = this.videoData.findIndex((item) => {
          if (item == this.videoRow) {
            return true;
          }
        });
        this.videoData.splice(index, 1);
        this.deleteVideoDialogVisible = false;
      },
  
      onPreview() {
        let routeUrl = this.$router.resolve({
          path: "/ProductPosterPreview",
          query: {
            appid: this.appid,
            shelvesid: this.shelvesid,
            posters: JSON.stringify(this.posterData),
          },
        });
        window.open(routeUrl.href, "_blank");
      },
  
      handleClose(done) {
        // 空函数, 防止dialog被不小心关闭
      },
  
      sortPoster() {
        this.posterData.sort(commonUtil.sortAsc, "sort");
        this.posterTableKey++;
      },
  
      sortVedio() {
        this.videoData.sort(commonUtil.sortAsc, "sort");
        this.videoTableKey++;
      },
  
      sortTableData() {
        this.tableData.sort(commonUtil.sortAsc, "sort");
        this.tableDataKey++;
      },
         //获取积分组列表
         pointgrouplist() {
            //获取积分组列表
            rejecthttp(
         true,
         "get",
         "/manage/point/pointgrouplist",
         { appid: "188", search: "" },
         this,
         (doc) => {
         changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
                        // this.$message({
                        //     type: "success",
                        //     message:"获取积分组接口成功"
                        //     });
            console.log(doc.data);
            // 添加总条数
            this.pointGroupList = doc.data.data;
            this.pointGroupList.forEach((any) => {
            any.editdate = commonUtil.formatDate(any.editdate);
            });
            }
            }
            );
        },
    },
    created() {
      this.appid = this.$route.query.appid ? this.$route.query.appid : 0;
      if (this.$route.query.id) {
        this.shelvesid = this.$route.query.id;
        this.isEditMode = this.$route.query.isEditMode ? true : false;
        this.isInit = false;
      }
      this.refresh();
    },
    computed: {},
    // // 隐藏固定栏
    // destroyed () {
    //   var topFix=document.querySelector('.topFix')
    //   // 固定栏隐藏
    //   topFix.style.display='none'
    // }
  };
  </script>
  
  <style scoped>
  .el-table /deep/ td {
    user-select: text !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/products/GoodsDetail.vue